<template>
  <div class="main">
    <div class="nav">基础资料</div>
    <div class="content">
      <div class="title">
        <h4>商品标题</h4>
        <el-input class="goodsInput" v-model="goodsTitle" placeholder="请输入商品标题"></el-input>
      </div>
      <div class="series">
        <h4>商品系列</h4>
        <el-select
          class="goodsInput"
          v-model="categoryId"
          placeholder="请选择商品系列"
          @change="categoryIdChange"
        >
          <el-option
            v-for="item in shopcategoryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <span @click="$refs.dialog.open()">+创建商品系列</span>
      </div>
    </div>
    <!-- 商品介绍 -->
    <div class="nav">商品介绍</div>
    <div class="goodsIntroduce">
      <!-- 富文本 -->
      <vue-ueditor-wrap v-model="msg" :config="myConfig"></vue-ueditor-wrap>
    </div>
    <!-- 商品属性 -->
    <div class="nav">商品属性</div>
    <div class="goodsAttr">
      <div v-for="(item,index) in attrList" :key="index">
        <h4>
          <span>选项{{ index+1 }}</span>
          <span class="remove" @click="removeAttr(index)">删除</span>
        </h4>
        <div class="oinput">
          <!-- 属性名 -->
          <el-select
            class="attr"
            v-model="item.attr"
            placeholder="请选择属性"
            @change="keyvalueChange(item,index)"
            @visible-change="visibleChange"
          >
            <el-option
              v-for="(itm,idx) in keyvalueList"
              :key="idx"
              :label="itm.key"
              :value="itm.key"
              :disabled="itm.disabled"
            ></el-option>
            <el-option value class="add">
              <span @click="addOneAttr(index)">+添加属性</span>
            </el-option>
          </el-select>
          <!-- 属性值 -->
          <div class="attrChild">
            <div>
              <el-tag
                :key="idx"
                v-for="(tag,idx) in item.attrs"
                closable
                :disable-transitions="false"
                @close="handleClose(tag,index)"
              >{{tag}}</el-tag>
            </div>
            <input
              type="text"
              class="attrChildInput"
              v-model="item.input"
              ref="saveTagInput"
              size="small"
              placeholder="请用回车各个选项"
              @keyup.enter="handleInputConfirm(index,item)"
            />
          </div>
        </div>
      </div>
      <span class="addAttr" @click="addAttr">+ 继续添加属性</span>
      <div class="moreAttr">
        <h2>多属性</h2>
        <ul class="navTitle">
          <li>多属性</li>
          <li>图片</li>
          <li>原价</li>
          <li>现价</li>
          <li>SKU</li>
          <li>操作</li>
        </ul>
        <div class="items">
          <ul class="item" v-for="(item,index) in this.attrLists" :key="index">
            <li>{{ item.item }}</li>
            <li>
              <img :src="'https://api.onesb2c.com'+item.pics[0]" alt v-if="item.pics" />
              <h3 @click="addImageOpen(index)">
                <i class="el-icon-plus"></i>
              </h3>
              <h3 @click="foundImageOpen(index)">
                <i class="el-icon-view"></i>
              </h3>
            </li>
            <li>
              <div>
                <span>$</span>
                <input type="text" v-model="item.origPrice" />
              </div>
            </li>
            <li>
              <div>
                <span>$</span>
                <input type="text" v-model="item.price" />
              </div>
            </li>
            <li>
              <div>
                <input type="text" v-model="item.sku" />
              </div>
            </li>
            <li @click="remove(index)">删除</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="nav">推荐关联商品</div>
    <div class="recommend">
      <el-button type="primary" @click="dialogRecommend = true" size="small">选择关联商品</el-button>
      <el-dialog
        title="推荐关联商品"
        :visible.sync="dialogRecommend"
        style="z-index: 10001;"
        width="650px"
      >
        <goods-list></goods-list>
        <div class="foot">
          <el-button type="primary" @click="dialogRecommend = false" size="small">确 定</el-button>
          <el-button @click="dialogRecommend = false" size="small">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="btn">
      <el-button type="primary" size="small" @click="submitAll">确 定</el-button>
      <el-button size="small">取 消</el-button>
    </div>
    <!-- 新增系列产品 -->
    <dialog-addseries ref="dialog" :singleImg="true" :changeGoodSeries="changeGoodSeries"></dialog-addseries>
    <!-- 添加商品图片 -->
    <el-dialog
      title="添加商品图片"
      :visible.sync="dialogFormVisible2"
      width="650px"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="添加商品图片:" label-width="120px">
          <upload-img ref="uploadImgs" :fatherMethod="fatherMethod" @ImageRes="getImages"></upload-img>
        </el-form-item>
      </el-form>
      <div class="addSeries">
        <div class="btns" style="text-align: center;">
          <el-button size="small" type="primary" @click="addImage">确 定</el-button>
          <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 查看商品图片 -->
    <el-dialog
      title="查看商品图片"
      :visible.sync="dialogFormVisible3"
      width="650px"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="商品图片:" label-width="120px" class="foundImage">
          <img
            :src="'https://api.onesb2c.com'+item"
            alt
            v-for="(item,index) in this.IMAGES"
            :key="index"
          />
        </el-form-item>
      </el-form>
      <div class="addSeries">
        <div class="btns" style="text-align: center;">
          <el-button size="small" type="primary" @click="dialogFormVisible3 = false">确 定</el-button>
          <el-button size="small" @click="dialogFormVisible3 = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dialogAddseries from "../../components/dialogAddseries";
import uploadImg from "../../components/uploadImg";
import goodsList from "./components/goodsList";
import VueUeditorWrap from "vue-ueditor-wrap";
import { goodsAdd, getShopcategory, getkeyvalue } from "../../service";
export default {
  // name: "text",
  data() {
    return {
      dialogFormVisible: false, //新增系列产品弹出层
      dialogFormVisible2: false, //添加商品图片弹出层
      dialogFormVisible3: false, //查看商品图片弹出层
      form: {},
      goodsTitle: "",
      attrTags: [],
      inputVisible: false,
      oldPrice: "",
      nowPrice: "",
      input: "",
      attrList: [{ attr: "", attrs: [], input: "" }], //商品属性
      attrLists: [], //多属性列表
      options: [],
      shopcategoryList: [], //商品系列列表
      categoryId: null, //选中的商品系列id
      keyvalueList: [], //商品属性列表
      INDEX: null, //商品列表中当前点击的添加图片或查看图片的下标
      IMAGES: [], //商品列表中当前点击的查看图片的数组
      change_nosave: true, //是否触发导航守卫,默认触发
      value: "",
      // 关联推荐商品
      dialogRecommend: false,
      //  富文本
      msg: "",
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 240,
        // 初始容器宽度
        initialFrameWidth: "100%",
        UEDITOR_HOME_URL: "/UEditor/",
        serverUrl: "",
      },
    };
  },
  created() {
    this.Shopcategory();
  },
  methods: {
    // 多属性组合
    getCombination(array) {
      let resultArr = [];
      array.forEach((arrItem) => {
        if (resultArr.length === 0) {
          let firstItem = [];
          arrItem.forEach((item) => {
            firstItem.push([item]);
          });
          resultArr = firstItem;
        } else {
          const emptyArray = [];
          resultArr.forEach((item) => {
            arrItem.forEach((value) => {
              emptyArray.push([...item, value]);
            });
          });
          resultArr = emptyArray;
        }
      });
      return resultArr;
    },
    // 执行多属性组合方法
    madeCombination() {
      // 动态改变多属性列表,实现联动
      let arr = [];
      this.attrList.map((el, i) => {
        arr.push(el.attrs);
      });
      // 调用上面的组合方法  arr是组合之前的数组例如[['32g','64g','128g'],['华为','小米','苹果','oppo'],['白色','黑色']]
      let end = this.getCombination(arr);
      this.attrLists = [];
      end.map((el) => {
        let str = "";
        el.map((item, i) => {
          str += item + "/";
        });
        str = str.substr(0, str.length - 1);
        this.attrLists.push({ item: str });
      });
    },
    // 移除每个属性值
    handleClose(tag, i) {
      this.attrList[i].attrs.splice(this.attrList[i].attrs.indexOf(tag), 1);
      this.madeCombination();
    },
    // 回车添加选项 => 请用回车各个选项
    handleInputConfirm(i, item) {
      let input = this.attrList[i].input;
      if (input) {
        if (this.attrList[i].attrs.length === 0) {
          this.attrList[i].attrs.push(input);
          this.keyvalueList.map((el) => {
            if (el.key === item.attr) {
              el.values.push({
                value: input,
              });
            }
          });
        } else {
          // 去重
          let flag = true;
          this.attrList[i].attrs.map((item, index) => {
            if (input === item) {
              flag = false;
            }
          });
          // 没有重复就添加
          if (flag) {
            this.attrList[i].attrs.push(input);
            this.keyvalueList.map((el) => {
              if (el.key === item.attr) {
                el.values.push({
                  value: input,
                });
              }
            });
          }
        }
      }
      this.attrList[i].input = "";
      this.madeCombination();
    },
    // 添加属性
    addAttr() {
      this.attrList.push({ attr: "", attrs: [], input: "" });
    },
    // 删除某个添加属性列
    removeAttr(index) {
      this.keyvalueList.map((el) => {
        if (el.key === this.attrList[index].attr) {
          el.disabled = false;
        }
      });
      this.attrList.splice(index, 1);
      this.madeCombination();
    },
    // 继续添加属性名
    addOneAttr(i) {
      this.$prompt("请输入属性", "添加属性", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "属性不能为空",
      })
        .then(({ value }) => {
          this.keyvalueList.splice(this.keyvalueList.length, 0, {
            id: 0,
            key: value,
            values: [],
            disabled:true
          });
          this.$message({
            type: "success",
            message: "您添加的属性是: " + value,
          });
          this.attrList[i].attr = value;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
      document.querySelector(".el-message-box__btns").style.textAlign =
        "center";
    },
    //最后提交按钮
    submitAll() {
      this.getGoodsAdd();
    },
    // 请求添加商品接口
    getGoodsAdd() {
      // 获取tSkuKeyValues
      let tSkuKeyValues = [];
      this.attrList.map((el, i) => {
        tSkuKeyValues.push({
          name: el.attr,
          values: [],
        });
        el.attrs.map((item) => {
          tSkuKeyValues[i].values.push({
            name: item,
          });
        });
      });
      // 获取tSkuMaps
      let tSkuMaps = [];
      let keyValues = []; //多属性组合
      let arr = [];
      if (this.attrList.length === 1) {
        this.attrLists.map((item, index) => {
          this.attrList.map((el, i) => {
            keyValues.push({
              key: el.attr,
              value: "",
            });
          });
          arr.push(...item.item.split("/"));
          arr.map((itm, idx) => {
            keyValues[idx].value = itm;
          });
          tSkuMaps.push({
            keyValues: keyValues.slice(keyValues.length - 1, keyValues.length),
            sku: {
              name: item.sku, //sku
            },
            goodsChild: {
              pics: item.pics != [] ? item.pics : [], //图片
              price: parseFloat(item.price), //现价
              origPrice: parseFloat(item.origPrice), //原价
            },
          });
        });
      } else {
        this.attrLists.map((item, index) => {
          this.attrList.map((el, i) => {
            keyValues.push({
              key: el.attr,
              value: "",
            });
          });
          arr.push(...item.item.split("/"));
          arr.map((itm, idx) => {
            keyValues[idx].value = itm;
          });
          tSkuMaps.push({
            keyValues: keyValues.slice(keyValues.length - 2, keyValues.length),
            sku: {
              name: item.sku, //sku
            },
            goodsChild: {
              pics: item.pics != [] ? item.pics : [], //图片
              price: parseFloat(item.price), //现价
              origPrice: parseFloat(item.origPrice), //原价
            },
          });
        });
      }
      let params = {
        sellerId: 1,
        categoryId: this.categoryId, //商品系列
        goods: {
          name: this.goodsTitle, //商品标题
          introduce: this.msg, //富文本
        },
        tSkuKeyValues: tSkuKeyValues,
        tSkuMaps: tSkuMaps,
      };
      //-----start------ 将params已有id上  -----start------
      params.tSkuKeyValues.map((el, i) => {
        // 给tSkuKeyValues赋值id
        this.keyvalueList.map((item, index) => {
          // tSkuKeyValues下的name id赋值
          if (el.name === item.key && item.id >= 0) {
            el.id = item.id;
          }
          //tSkuKeyValues下的values的name id赋值
          el.values.map((it, id) => {
            item.values.map((itm, idx) => {
              if (it.name === itm.value && itm.id >= 0) {
                it.id = itm.id;
              }
            });
          });
        });
      });
      // -----end------ 将params已有id上  -----end------
      let flag = true;
      params.tSkuMaps.map((el) => {
        el.keyValues.map((itm) => {
          if (itm.key === "") {
            flag = false;
          }
        });
      });
      if (flag) {
        goodsAdd(params).then(res => {
          if (res.data.code === 0) {
            // 不触发导航守卫
            this.change_nosave = false;
            this.$message({
              message: "提交成功！",
              type: "success",
              duration: 1000,
              onClose: () => {
                this.$router.push({
                  path: "/goods"
                });
              }
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }else{
        this.$message({
          message: '请选择属性',
          type: 'warning'
        });
      }
    },
    // 新建商品获取商品系列
    Shopcategory(name) {
      getShopcategory().then((res) => {
        if (res.data.code === 0) {
          this.shopcategoryList = res.data.result;
          if(name != undefined){
            this.shopcategoryList.map(el=>{
              if( el.name === name ){
                this.categoryId =el.id;
              }
            })
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 新建商品获取商品属性
    keyvalue() {
      let params = {
        id: this.categoryId,
      };
      getkeyvalue(params).then((res) => {
        if (res.data.code === 0) {
          this.keyvalueList = res.data.result;
        }
      });
    },
    // 商品系列发生改变  => 重新获取商品属性
    categoryIdChange() {
      this.keyvalue();
    },
    // 商品属性选中发生改变
    keyvalueChange(values, index) {
      // 选过之后，这项将不会重复点击选中
      this.attrList.map((el) => {
        this.keyvalueList.map((itm) => {
          itm.disabled = false;
        });
      });
      this.attrList.map((el) => {
        this.keyvalueList.map((itm) => {
          if (el.attr === itm.key) {
            itm.disabled = true;
          }
        });
      });

      this.keyvalueList.map((el) => {
        if (el.key === this.attrList[index].attr) {
          el.disabled = false;
        }
      });
      this.attrList[index].attrs = [];
      this.keyvalueList.map((el) => {
        if (el.key === values.attr) {
          el.disabled = true;
        }
        if (el.key === values.attr && el.values.length != 0) {
          el.values.map((item) => {
            this.attrList[index].attrs.push(item.value);
          });
        }
      });
      this.madeCombination();
    },
    // 添加商品图片
    addImage() {
      this.$refs.uploadImgs.$emit("bridge", true);
    },
    // 上传图片子组件调用的父组件方法
    fatherMethod() {
      this.$message({
        message: "图片上传成功！",
        type: "success",
      });
    },
    // 打开添加商品图片
    addImageOpen(i) {
      this.dialogFormVisible2 = true;
      this.INDEX = i;
    },
    // 打开查看商品图片
    foundImageOpen(i) {
      this.dialogFormVisible3 = true;
      this.INDEX = i;
      this.IMAGES = this.attrLists[i].pics;
    },
    // 获取上传图片子组件传递过来的图片res
    getImages(res) {
      let arr = [];
      res.data.result.map((el) => {
        arr.push(el.relativeUrl);
      });
      this.attrLists[this.INDEX].pics = arr;
      this.dialogFormVisible2 = false;
    },
    // 多属性删除操作
    remove(i) {
      this.$confirm("您正在使用删除操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.attrLists.splice(i, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 当在创建商品系列成功之后，子组件调用父组件方法
    changeGoodSeries(name){
      this.Shopcategory(name);
    },
    // 当选属性是,下拉框出现，判断是否选中系列，没有则提示选择商品系列
    visibleChange(val){
      if( val && this.categoryId === null){
        this.$message({
          message: '请先选择商品系列',
          type: 'warning'
        });
      }
    }
  },
  mounted() {
    // 阻止页面刷新，以防数据丢失
    window.onbeforeunload = function (e) {
      var dialogText = "Dialog text here";
      e.returnValue = dialogText;
      return dialogText;
    };
  },
  components: {
    dialogAddseries,
    goodsList,
    VueUeditorWrap,
    uploadImg,
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (this.change_nosave) {
      this.$confirm("您的操作将不会被保存, 是否继续??", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          next();
        })
        .catch(() => {});
    } else {
      next();
    }
  },
};
</script>

<style lang="less" scoped>
.add {
  padding: 0;
  span {
    display: inline-block;
    padding: 0 20px;
    width: 100%;
    &:hover {
      cursor: pointer;
    }
  }
}
.main {
  padding-top: 10px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  > .content {
    padding-left: 30px;
    margin-bottom: 30px;
    > .title,
    > .series,
    > .ImgUpload {
      h4 {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 20px;
        margin-top: 10px;
      }
      .goodsInput {
        width: 500px;
        height: 40px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
      }
      > span {
        margin-left: 6px;
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 119, 255, 1);
        line-height: 20px;
        &:hover {
          cursor: pointer;
        }
      }
    }
    > .ImgUpload {
      > .uploadImages {
        // width: 68px;
        // height: 68px;
      }
    }
    > .series {
      .tags {
        display: flex;
        align-items: center;
      }
    }
    > .price {
      > h4 {
        line-height: 20px;
        margin-top: 10px;
      }
      > .priceInput {
        display: flex;
        margin-bottom: 30px;
        > .nowPrice,
        > .oldPrice {
          margin-right: 20px;
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          line-height: 30px;
          font-size: 14px;
          > span:first-child {
            display: inline-block;
            width: 40px;
            text-align: center;
            color: #a4a4a4;
          }
          > input {
            width: 50px;
          }
          > span:last-child {
            display: inline-block;
            width: 20px;
          }
        }
      }
    }
  }
  > .nav {
    line-height: 24px;
    padding-left: 30px;
    font-size: 18px;
    font-weight: 600;
  }
  > .goodsAttr > div:first-child {
    margin-top: 0px;
  }
  > .goodsAttr > div {
    > h4 {
      width: 46%;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      > span:first-child {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(34, 34, 34, 1);
        line-height: 20px;
      }
      > span:last-child {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        line-height: 20px;
      }
    }
    > .oinput {
      width: 46%;
      display: flex;
      justify-content: space-between;
      > .attr {
        width: 130px;
        height: 40px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
      }
      > .attrChild {
        width: 280px;
        min-height: 40px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid #dcdfe6;
        display: flex;
        flex-direction: column;
        > .attrChildInput {
          padding-left: 12px;
          margin-top: 6px;
        }
        /deep/ .el-tag.el-tag--light {
          height: 24px;
          line-height: 24px;
          margin-bottom: 4px;
        }
        /deep/ .el-tag.el-tag--light:first-child {
          margin-left: 10px;
        }
      }
    }
  }
  > .goodsAttr {
    padding: 4px 0 0px 30px;
    .addAttr {
      display: flex;
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 119, 255, 1);
      line-height: 24px;
      margin-bottom: 20px;
      &:hover {
        cursor: pointer;
      }
    }
    .moreAttr > h2 {
      width: 46%;
      height: 26px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(34, 34, 34, 1);
      line-height: 26px;
      border-bottom: 1px solid rgba(216, 216, 216, 1);
    }
    .moreAttr {
      > .navTitle,
      .item {
        display: flex;
        line-height: 36px;
        align-items: center;
        padding: 0 25px;
        margin-right: 20px;
        > li:nth-child(1) {
          width: 20%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
        > li:nth-child(2) {
          width: 30%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
        > li:nth-child(3) {
          width: 12%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
        > li:nth-child(4) {
          width: 12%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
        > li:nth-child(5) {
          width: 14%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
        > li:nth-child(6) {
          width: 8%;
          margin-left: 40px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          text-align: center;
        }
      }
      > .items {
        margin-bottom: 30px;
      }
      .item {
        background: rgba(246, 249, 252, 1);
        margin-bottom: 5px;
        > li {
          height: 60px;
          line-height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          width: 50px;
          height: 50px;
        }
        > li:last-child {
          &:hover {
            cursor: pointer;
          }
        }
        > li > div {
          width: 100px;
          height: 34px;
          line-height: 34px;
          background: rgba(255, 255, 255, 1);
          border-radius: 2px;
          border: 1px solid rgba(216, 216, 216, 1);
          position: relative;
          text-align: left;
          > span:first-child {
            display: inline-block;
            margin-left: 12px;
            text-align: center;
            color: #999999;
          }
          > input {
            width: 60%;
            margin-left: 12px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
          }
        }
        > li:nth-child(2) {
          img {
            margin-right: 10px;
          }
          > h3 {
            width: 50px;
            height: 50px;
            box-sizing: border-box;
            border: 1px solid #d8d8d8;
            line-height: 50px;
            font-size: 20px;
            color: #d8d8d8;
            margin-right: 10px;
            &:hover {
              cursor: pointer;
            }
          }
        }
        > li:nth-child(5) > div {
          width: 120px;
        }
      }
    }
    .remove {
      cursor: pointer;
    }
  }
  > .goodsIntroduce {
    padding: 10px 20px 0 30px;
    margin-bottom: 30px;
  }
  > .inventory {
    padding: 10px 20px 0 30px;
    margin-bottom: 20px;
    > .sku {
      width: 36%;
      margin-right: 10px;
      display: inline-block;
      h3 {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(34, 34, 34, 1);
        line-height: 20px;
      }
    }
  }
  .recommend {
    padding: 10px 20px 0 30px;
    .foot {
      text-align: center;
    }
  }
  .btn {
    margin-top: 26px;
    margin-bottom: 50px;
    text-align: center;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 150px;
  margin-left: 10px;
  vertical-align: bottom;
}
.main > .content > .series span[data-v-4a269b9c] {
  height: 26px;
  line-height: 26px;
}
/deep/ .el-dialog__wrapper {
  z-index: 10001 !important;
}
/deep/ .w-e-text-container {
  z-index: 100 !important;
}
/deep/ .el-dialog__body {
  padding-top: 0px !important;
}
.foundImage {
  img {
    width: 68px;
    height: 68px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
</style>